import clsx from 'clsx'

interface Props {
  height?: number | string
  width?: number | string
  className?: string
}

export const Skeleton = ({ height = 80, width = '100%', className }: Props) => {
  return (
    <div className={clsx('relative overflow-hidden bg-gray-300 rounded-md', className)} style={{ height, width }}>
      {/* shimmer */}
      <div className="absolute inset-0 animate-shimmer bg-gradient-to-r from-transparent via-white/60 to-transparent" />
    </div>
  )
}
